export const curriculumList: any[] = [
	{
		part: "공통",
		content: [
			{
				id: 0,
				left: "HTML & CSS",
				right: "기초 코딩 교육",
			},
			{
				id: 1,
				left: "Python",
				right: "기초 코딩 교육",
			},
			{
				id: 2,
				left: "Git & Figma",
				right: "기초 협업 교육",
			},
		],
	},
	{
		part: "기획디자인",
		content: [
			{
				id: 0,
				left: "Figma 심화",
				right: "UI 구현",
			},
			{
				id: 1,
				left: "프로토타이핑",
				right: "프로토타입 구현",
			},
			{
				id: 2,
				left: "서비스 기획",
				right: "역기획 스터디",
			},
			{
				id: 3,
				left: "UI·UX 디자인",
				right: "Material Design",
			},
			{
				id: 4,
				left: "데이터",
				right: "SQL 스터디",
			},
		],
	},
	{
		part: "프론트엔드",
		content: [
			{
				id: 0,
				left: "HTML & CSS 심화",
				right: "시맨틱 태그 레이아웃",
			},
			{
				id: 1,
				left: "Javascript 기초",
				right: "기본 문법",
			},
			{
				id: 2,
				left: "Javascript 심화",
				right: "DOM, 이벤트",
			},
			{
				id: 3,
				left: "React 기초",
				right: "Router, Hooks, styled-component",
			},
			{
				id: 4,
				left: "React 심화",
				right: "Context API, Redux, axios",
			},
		],
	},
	{
		part: "백엔드",
		content: [
			{
				id: 0,
				left: "Django 기초",
				right: "기본 문법",
			},
			{
				id: 1,
				left: "Blog / 1:n & m:n",
				right: "CRUD 실습",
			},
			{
				id: 2,
				left: "static & media",
				right: "static 파일, 사진 업로드",
			},
			{
				id: 3,
				left: "유저인증과 확장",
				right: "로그인, 회원가입 구현",
			},
			{
				id: 4,
				left: "DRF & 배포",
				right: "Django rest framework, Python anywhere",
			},
		],
	},
];

export const activityList: { id: number; left: string; right: string }[] = [
	{
		id: 0,
		left: "1학기 교육 활동",
		right: "2023.03 - 2023.07",
	},
	{
		id: 1,
		left: "아이디어톤",
		right: "2023.05 - 06",
	},
	{
		id: 2,
		left: "여름 MT",
		right: "2023.07.06 - 07",
	},
	{
		id: 3,
		left: "여기톤",
		right: "2023.07.14 - 15",
	},
	{
		id: 4,
		left: "중앙해커톤",
		right: "2023.07 - 08",
	},
	{
		id: 5,
		left: "신촌톤",
		right: "2023.08.25 - 26",
	},
	{
		id: 6,
		left: "대동제 리팩토링",
		right: "2023.09 - 10",
	},
	{
		id: 7,
		left: "졸업 프로젝트",
		right: "2023.11 - 2024.01",
	},
];
